import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  buildWorkOrderStockIssueUpdatePayload,
} from '#/api/momMgmt/workOrder/outbound/serializeOutboundWrite';

/**
 * PATCH `/mom/work-order/{workOrderId}/stock-issue/{stockIssueId}`（DRAFT）。
 *
 * @param {string} workOrderId
 * @param {string} stockIssueId
 * @param {object} values
 */
export async function updateWorkOrderStockIssue(
  workOrderId,
  stockIssueId,
  values,
) {
  const { data: raw } = await request.patch(
    `/mom/work-order/${workOrderId}/stock-issue/${stockIssueId}`,
    keysToSnake({
      ...buildWorkOrderStockIssueUpdatePayload(values),
      id: stockIssueId,
    }),
  );
  return parseVer4DetailResponse(raw);
}
